/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { navData } from "./navData";
import "./Sidenav.css";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/UHC_Lockup_wht_RGB.png";
import logo1 from "../../assets/UHC_U-mark_wht_RGB.png";
import { useAuth } from "react-oidc-context";
import GroupSelector from "./GroupSelector";
import { groupIndices } from "./indexData";
import { GlobalStateContext } from "../../GlobalStateProvider";
import { SiChatbot } from "react-icons/si";
const Sidenav = (props) => {
  const auth = useAuth();
  const profile = auth.user?.profile;
  const location = useLocation();
  const [indices, setIndices] = useState([]);
  const {indexType} = useContext(GlobalStateContext)

  // Function to get the merged indices based on the user's groups
  function getMergedIndices(groups) {
    // If groups has CoreBooster, return CoreBooster indices
    if (groups.includes("CoreBooster")) {
      console.log("CoreBooster");
      return groupIndices.CoreBooster;
    }

    // if type of group is string
    if (typeof groups === "string") {
      // Return the value of that string from the groupIndices if exists, otherwise return groupIndices.default
      return groupIndices[groups] ? groupIndices[groups] : groupIndices.default;
    }

    const mergedIndices = [];
    const uniqueIndices = new Set();

    groups.forEach((group) => {
      const indices = groupIndices[group];
      if (indices) {
        indices.forEach((indexObj) => {
          if (!uniqueIndices.has(indexObj.index)) {
            uniqueIndices.add(indexObj.index);
            mergedIndices.push(indexObj);
          }
        });
      }
    });

    if (mergedIndices.length === 0) {
      return groupIndices.default;
    }

    return mergedIndices;
  }

  useEffect(() => {
    setIndices(getMergedIndices(profile.msad_groups));
  }, []);

  return (
    <div className="sidenav">
      <div className="navhead">
        <img src={logo} alt="uhc logo" className="navlogo"></img>
        <img src={logo1} alt="uch logo" className="navlogo1"></img>
        <div className="hr">
          <hr />
        </div>
        <GroupSelector indices={indices} />
        <div className="hr">
          <hr />
        </div>
        {indexType === "excel" ? (
          <Link to="/chat">
            <div
              className={`sideitem ${
                location.pathname === "/chat" ? "active" : ""
              } `}
            >
              <SiChatbot className={`sideitemicon`} size={20} />
              <span className="linkText">Chat</span>
            </div>
          </Link>
        ) : (
          navData.map((item, index) => {
            return (
              <Link key={index} to={item.link}>
                <div
                  className={`sideitem ${
                    location.pathname === item.link ? "active" : ""
                  } `}
                >
                  {item.icon}
                  <span className="linkText">{item.text}</span>
                </div>
              </Link>
            );
          })
        )}
      </div>
      <div className="navfoot">
        <div className="userprofile">
          <span className="profile-initials">
            {profile.given_name.slice(0, 1)}
            {profile.family_name.slice(0, 1)}
          </span>
          <span className="profile-text">
            <span className="name">
              {profile.given_name} {profile.family_name}
            </span>
            <span className="id">{profile.sub}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Sidenav;
